
import React from "react";
import "./home.scss";

const Home = () => {
  return (
    <section id="home" className="home">
  {/* Carousel removed, restoring original video intro layout */}
      <video
        className="homeVideoIntro"
        autoPlay
        muted
        loop
      >
        <source src="assets/home-intro.mp4" type="video/mp4" />
        Your browser is not supported
      </video>
      <div className="homeDetails">
        <div className="container">
          <div className="row">
            <div className="slogan">
              <p>EL RINCONCITO DE LA PIZZA</p>
              <div>
                  <a
                    href="https://wa.me/50664521140?text=Hola.%20Quisiera%20ordenar%20pizza"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button>Order Now</button>
                  </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
